export default __webpack_public_path__ + "static/media/Animelab.60bc4414.svg";